module.exports = __webpack_public_path__ + "img/mitre-logo.1bc86a0f.jpg";